import dynamic from "next/dynamic";

export const DynamicContent071 = dynamic(() => import("./Content071"), {
  suspense: true,
});
